import { normalizePhaseViewIds } from '../../domain/phaseView';
import { phaseFilterMatchesRecord } from '../../domain/phaseApplicability';
import { recordClassIdentity } from '../../domain/recordClassIdentity';

/** null classes means Whole school; an empty selection means no assigned classes. */
export function normalizeTimelineWorkingView({ phaseIds = [], classIds = null, classes = [], canSeeReview = true } = {}) {
  return {
    phaseIds: normalizePhaseViewIds(phaseIds),
    classIds: classIds == null ? null : [...new Set(classIds)].sort(),
    // Names participate because they resolve records from the former class-label writer.
    classes: classIds == null ? [] : classes.map(({ id, name }) => ({ id, name: name || '' }))
      .sort((a, b) => String(a.id).localeCompare(String(b.id))),
    canSeeReview,
  };
}

export function matchesTimelineWorkingView(event, view, schoolId) {
  const record = event.originalData || event;
  if (!phaseFilterMatchesRecord(record, view.phaseIds, schoolId)) return false;
  if (!view.canSeeReview && (event.adjudicationStatus || record.adjudicationStatus) === 'pending') return false;
  if (view.classIds == null) return true;
  return view.classIds.includes(recordClassIdentity(record, view.classes).classId);
}
